// src/lib/urlCoupon.js
//
// Cupom que chega por link (?cupom=CODE) — e-mails dos A/Bs de cupom e campanhas.
//
// Sem isto o código só existe no corpo do e-mail: o CTA joga o paciente no
// funil e ele teria que digitar o cupom manualmente no paywall, no fim da
// jornada. Foi o que invalidou o funnel-coupon-ab (0 de 483 cupons resgatados;
// 37 dos 52 pagantes pagaram R$ 69,90 com cupom válido em mãos) — o teste
// mediu lembrete, não desconto.
//
// A captura acontece no boot (src/index.js) porque a navegação SPA e os
// redirects de rota descartam a query string antes do paywall abrir.

const STORAGE_KEY = 'urlCoupon';
const PARAM_NAMES = ['cupom', 'coupon'];
/** Formato dos códigos emitidos: CUPOM-XXXXXX, INDICAGANHO-…, BC1ST-…, etc. */
const CODE_RE = /^[A-Z0-9][A-Z0-9-]{3,31}$/;
/**
 * Janela de uso do código capturado. Os cupons dos A/Bs valem 24h e os manuais
 * 60–90 dias, mas a validade real é decidida pelo backend no /coupons/validate:
 * o teto aqui só evita carregar um código antigo de sessão em sessão.
 */
const MAX_AGE_MS = 7 * 24 * 3600 * 1000;

function normalizeCode(raw) {
  const code = String(raw || '').trim().toUpperCase();
  return CODE_RE.test(code) ? code : null;
}

function writeStores(payload) {
  const raw = JSON.stringify(payload);
  try { sessionStorage.setItem(STORAGE_KEY, raw); } catch {}
  try { localStorage.setItem(STORAGE_KEY, raw); } catch {}
}

/**
 * Lê `?cupom=` (ou `?coupon=`) da URL de chegada e persiste para o paywall.
 *
 * @param {string} [search] query string; default window.location.search
 * @returns {string|null} código capturado (normalizado) ou null
 */
export function captureUrlCoupon(search) {
  try {
    const qs = search != null
      ? search
      : (typeof window !== 'undefined' ? window.location.search : '');
    const params = new URLSearchParams(qs);
    for (const name of PARAM_NAMES) {
      const code = normalizeCode(params.get(name));
      if (code) {
        writeStores({ code, capturedAtMs: Date.now() });
        return code;
      }
    }
  } catch {}
  return null;
}

/** Código capturado ainda dentro da janela de uso, ou null. */
export function readUrlCoupon() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY) || localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const code = normalizeCode(parsed && parsed.code);
    if (!code) return null;
    const capturedAtMs = Number(parsed.capturedAtMs) || 0;
    if (capturedAtMs && Date.now() - capturedAtMs > MAX_AGE_MS) {
      clearUrlCoupon();
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

export function clearUrlCoupon() {
  try { sessionStorage.removeItem(STORAGE_KEY); } catch {}
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
}
